import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NotificationService} from "../../services/notifications/notification.service";
import {ActivatedRoute, Router} from "@angular/router";
import {OpenbandService} from "../../services/openband/openband.service";
import {Title} from "@angular/platform-browser";
import {PreferencesService} from "../../services/preferences/preferences.service";
import {FilterListPipe} from "../../helpers/pipes/filter-list-by-bib.pipe";
import {Account, Event, FileColumn, Participant, ParticipantField, UserRoles} from "../../domain/models";
import {millisToTime} from "../../domain/date-utils";
import {Subject} from "rxjs";
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {Clipboard} from "@angular/cdk/clipboard";
import * as XLSX from 'xlsx';
import {debounceTime, distinctUntilChanged, takeUntil} from 'rxjs/operators';

function getRandomInt() {
  return Math.floor(Math.random() * 10000).toString();
}

function makeid() {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < 20) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export class Sort {
  sortField: SortFields = SortFields.surname;
  sortType: SortTypes = SortTypes.asc;
}

enum SortFields {
  bib,
  surname,
  name,
  birthDate,
  event,
}

enum SortTypes {
  asc,
  desc,
}

@Component({
  selector: 'app-participants',
  templateUrl: './participants.component.html',
  styleUrls: ['./participants.component.scss']
})
export class ParticipantsComponent implements OnInit, OnDestroy {

  private subscription
  private searchSubject = new Subject<string>();
  private destroy$ = new Subject();

  selectedFile: File | null = null;
  columnMode: 'auto' | 'manual' = 'auto';
  fileColumns: FileColumn[] = [];
  previewData: any[][] = [];
  previewHeaders: string[] = [];

  participantFields: ParticipantField[] = [
    {key: 'bib', displayName: 'Номер участника', description: 'Стартовый номер', required: false},
    {key: 'name', displayName: 'Имя', description: 'Имя участника', required: true},
    {key: 'surname', displayName: 'Фамилия', description: 'Фамилия участника', required: true},
    {key: 'club', displayName: 'Клуб', description: 'Спортивный клуб', required: false},
    {key: 'phone', displayName: 'Телефон', description: 'Номер телефона', required: false},
    {key: 'dateOfBirth', displayName: 'Дата рождения', description: 'Дата рождения (YYYY-MM-DD)', required: false},
    {key: 'gender', displayName: 'Пол', description: 'Пол участника (М/Ж)', required: false},
    {key: 'category', displayName: 'Категория', description: 'Возрастная категория', required: false},
    {key: 'event', displayName: 'Дистанция', description: 'Название дистанции', required: false},
    {key: 'tag', displayName: 'Чип', description: 'Номер чипа', required: false},
    {key: 'uin', displayName: 'УИН', description: 'Уникальный идентификационный номер', required: false},
    {key: 'externalId', displayName: 'Внешний ID', description: 'Внешний идентификатор', required: false},
    {key: 'estimatedStart', displayName: 'Ожидаемый старт', description: 'Время старта', required: false}
  ];

  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
  participants: Participant[] = [];
  filteredParticipants: Participant[] = [];
  filteredParticipantsForMassAssign: Participant[] = [];
  searchQuery: string = "";

  currentEvent: Event;
  categories: string[] = [""];
  genders: string[] = ["", "Male", "Female"];
  events: string[] = [""];
  currentSort = new Sort();
  participantToEdit: Participant = new Participant();
  eventId: string = "";

  pipe = new FilterListPipe();

  account: Account = new Account();

  bibAssignForm: FormGroup;
  selectedParticipants: Set<string> = new Set();
  massEditForm: FormGroup;

  createParticipantForm: FormGroup;

  selectedExportFormat: string = 'so-import';

  isIssuanceEvent: boolean = false;
  mergedParticipants: any[] = [];
  selectedEventsForIssuance: string[] = [];
  issuanceForm: FormGroup;
  issuanceParticipant: any = {};

  exportFormats = {
    standard: {
      name: 'Стандартный',
      headers: ['bib', 'tag', 'name', 'surname', 'club', 'phone', 'dateOfBirth', 'gender', 'event', 'category']
    },
    extended: {
      name: 'Расширенный (заявки)',
      headers: ['Группа', 'Пол', 'Фамилия', 'Имя', 'Телефон', 'Команда', 'Код', 'Регион', 'Год', '№ чипа',
        'Для оперативной связи куда вам лучше написать, если что?', 'Примечания', 'Кем подана',
        'E-mail', 'Номер заявки', 'Время подачи', 'Статус', 'Дата оплаты', 'Сумма', 'Промокод',
        'Тип оплаты', 'Расчет суммы', 'Информация об оплате', 'Вошел по ссылке']
    },
    sportorg: {
      name: 'SportOrg',
      headers: ['surname', 'name', 'bib']
    },
    copernico: {
      name: 'Copernico',
      headers: ['bib', 'tag', 'name', 'surname', 'club', 'phone', 'dateOfBirth', 'gender', 'event', 'category']
    }
  };

  cleanValue(value: string | undefined): string {
    if (!value || value === 'undefined') return '';
    return value.replace(/undefined/g, '').trim();
  }

  mapGenderToRussian(gender: string): string {
    switch (gender) {
      case 'Male':
        return 'М';
      case 'Female':
        return 'Ж';
      default:
        return '';
    }
  }

  extractYearFromDate(dateString: string): string {
    if (!dateString) return '';

    try {
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        return date.getFullYear().toString();
      }

      const yearMatch = dateString.match(/(\d{4})/);
      return yearMatch ? yearMatch[1] : '';
    } catch (e) {
      return '';
    }
  }

  downloadFile(content: string, filename: string): void {
    const url = 'data:text/csv;charset=utf-8,' + encodeURIComponent(content);
    const link = document.createElement('a');
    link.download = filename;
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    this.clipboard.copy(content)
    this.notifyService.showSuccess("Скопировано в буфер обмена")
  }

  generateImportToSportOrg(participants: Participant[]): string {
    let csv = "";

    participants.forEach((x: Participant) => {
      if (x.bib != "" && x.bib != null) {
        csv += `${x.surname} ${x.name}\t${x.bib}\n`;
      }
    });

    return csv
  }

  generateExtendedCSV(participants: Participant[]): string {
    let csv = "Группа;Пол;Фамилия;Имя;Телефон;Команда;Код;Регион;Год;№ чипа;Для оперативной связи куда вам лучше написать, если что?;Примечания;Кем подана;E-mail;Номер заявки;Время подачи;Статус;Дата оплаты;Сумма;Промокод;Тип оплаты;Расчет суммы;Информация об оплате;Вошел по ссылке\n";

    participants.forEach((x: Participant) => {
      const birthYear = this.extractYearFromDate(x.dateOfBirth);
      csv += `${this.cleanValue(x.category)};${this.mapGenderToRussian(x.gender)};${this.cleanValue(x.surname)};${this.cleanValue(x.name)};${this.cleanValue(x.phone)};${this.cleanValue(x.club)};${this.cleanValue(x.bib)};;;;;${this.cleanValue(x.tag)};;;;;;;;;;;;;;;;\r\n`;
    });

    return csv;
  }

  parseGenderForSportorg(gender: string): string {
    if (gender == "Female") return "Ж";
    if (gender == "Male") return "М";
  }

  parseYearForSportorg(year: string): string {
    return "2000"
    return this.convertDateFormat(year, "YYYY")
  }

  generateSportOrgCSV(participants: Participant[]): string {
    let content = "Группа;Пол;Фамилия;Имя;Телефон;Команда;Код;Регион;Год;Примечания;Кем подана;E-mail;Номер заявки;Время подачи;Статус;Дата оплаты;Сумма;Промокод;Тип оплаты;Расчет суммы;Информация об оплате;Вошел по ссылке;\n";

    participants.forEach((x: Participant) => {
      content += `${this.cleanValue(x.event)};${this.parseGenderForSportorg(this.cleanValue(x.gender))};${this.cleanValue(x.surname)};${this.cleanValue(x.name)};${this.cleanValue("+79999999999")};\"${this.cleanValue(x.club)}\";77;Лично;${this.parseYearForSportorg(this.cleanValue(x.dateOfBirth))};0;0;0;${this.cleanValue(x.externalId)};0;0;0;0;0;0;0;0;0;0;0;\n`;
      console.log(x)
    });

    return content;
  }

  generateCopernicoCSV(participants: Participant[]): string {
    let s = "" +
      "bib;" +
      "tag;" +
      "name;" +
      "surname;" +
      "club;" +
      "phone;" +
      "Date of Birth;" +
      "Gender;" +
      "Event;" +
      "category\n";
    this.participants.forEach((x: Participant) => {
      console.log(x);
      s += `${x.bib?.replace("undefined", "") || ""};${x.tag?.replace("undefined", "") || ""};${x.name?.replace("undefined", "") || ""};${x.surname?.replace("undefined", "") || ""};${x.club?.replace("undefined", "") || ""};${x.phone?.replace("undefined", "") || ""};${this.convertDateFormat(x.dateOfBirth, this.currentDateFormat)};${x.gender};${x.event?.replace("undefined", "") || ""};${x.category?.replace("undefined", "") || ""}\r\n`
    })
    return s
  }

  downloadCSVWithFormat(eventFilter: string, format: string) {
    let participantsToExport = this.participants;

    if (eventFilter !== 'all') {
      participantsToExport = this.participants.filter(x => x?.event?.includes(eventFilter));
    }

    let csvContent = '';
    let filename = '';

    console.log(format)
    switch (format) {
      case 'so-import':
        csvContent = this.generateImportToSportOrg(participantsToExport);
        filename = `participants-so-import-${eventFilter}.txt`;
        break;

      case 'extended':
        csvContent = this.generateExtendedCSV(participantsToExport);
        filename = `participants-extended-${eventFilter}.csv`;
        break;

      case 'sportorg':
        csvContent = this.generateSportOrgCSV(participantsToExport);
        filename = `participants-sportorg-${eventFilter}.csv`;
        break;

      case 'copernico':
        csvContent = this.generateCopernicoCSV(participantsToExport);
        filename = `participants-copernico-${eventFilter}.csv`;
        break;

      default:
        csvContent = this.generateImportToSportOrg(participantsToExport);
        filename = `participants-${eventFilter}.csv`;
    }

    this.downloadFile(this.removeBOM(csvContent.slice(0, -1)), filename);
  }

  removeBOM(str: string): string {
    return str.replace(/^\uFEFF/, '');
  }

  getEventsForDownload(): string[] {
    return this.events.filter(x => x != "")
  }

  getAvailableEvents(): string[] {
    return this.events.filter(x => x != "")
  }

  contains(obj: string, list: string[]) {
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i] === obj) {
        return true;
      }
    }
    return false;
  }

  isFullScreen: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: OpenbandService,
    private notifyService: NotificationService,
    private modalService: NgbModal,
    private titleService: Title,
    private prefs: PreferencesService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private clipboard: Clipboard,
    private cdr: ChangeDetectorRef
  ) {
    titleService.setTitle(`Участники`);
    route?.queryParams?.subscribe(params => {
        var old = prefs.appPreferences
        var newToken = params['token']
        if (newToken?.length > 3) {
          old.token = newToken
          prefs.setAppPreferences(old)
        } else {
        }
      }
    )
    route.params.subscribe(params => {
        this.parseRouteParams(params.id.toString())
        this.loadParticipants()
        this.loadEvent()
        this.loadAccount()
      }
    )
    this.initBibAssignForm();
    this.initCreateParticipantForm();
    this.initIssuanceForm();
    this.massEditForm = this.fb.group({});
  }

  initBibAssignForm() {
    this.bibAssignForm = this.fb.group({
      bibNumbers: ['', Validators.required],
      searchQuery: [''],
      selectedParticipants: [[]]
    });

    // Подписываемся на изменения в поле поиска
    this.bibAssignForm.get('searchQuery').valueChanges.subscribe(query => {
      this.filterParticipants();
    });
  }

  initCreateParticipantForm() {
    this.createParticipantForm = this.fb.group({
      surname: ['', Validators.required],
      name: ['', Validators.required],
      club: [''],
      phone: [''],
      dateOfBirth: [''],
      category: [''],
      event: [''],
      bib: ['']
    });
  }

  initIssuanceForm() {
    this.issuanceForm = this.fb.group({
      selectedEvents: [[]],
      selectedParticipants: [[]]
    });
  }

  mergeParticipantsByFioAndBirthYear(): void {
    const mergedMap = new Map<string, any>();

    this.participants.forEach(participant => {
      const birthYear = this.extractYearFromDate(participant.dateOfBirth);
      const key = [
        (participant.surname || '').toLowerCase().trim(),
        (participant.name || '').toLowerCase().trim(),
        this.extractYearFromDate(participant.dateOfBirth),
        // (participant.phone || '').replace(/\D/g, '')
      ].join('_');

      if (mergedMap.has(key)) {
        const existing = mergedMap.get(key);
        if (!existing.events.includes(participant.event)) {
          existing.events.push(participant.event);
        }
        if (participant.event !== 'Входной билет') {
          const participantWithEvent = {
            id: participant.id,
            event: participant.event
          };
          const existingParticipant = existing.participantIds.find((item: any) =>
            item.id === participant.id && item.event === participant.event
          );
          if (!existingParticipant) {
            existing.participantIds.push(participantWithEvent);
          }
        }

        if (participant.bib || participant.event === 'Входной билет') {
          const bibWithEvent = {
            bib: participant.bib || '',
            event: participant.event,
            issuanceStatus: participant.issuanceStatus || 'not_issued',
            issuedAt: participant.issuedAt,
            issuedBy: participant.issuedBy
          };
          const existingBib = existing.allBibNumbers.find((item: any) =>
            item.bib === bibWithEvent.bib && item.event === participant.event
          );
          if (!existingBib) {
            existing.allBibNumbers.push(bibWithEvent);
          }
        }
      } else {
        mergedMap.set(key, {
          id: participant.id,
          surname: participant.surname,
          name: participant.name,
          dateOfBirth: participant.dateOfBirth,
          birthYear: birthYear,
          events: participant.event ? [participant.event] : [],
          participantIds: participant.event !== 'Входной билет' ? [{
            id: participant.id,
            event: participant.event
          }] : [],
          allBibNumbers: (participant.bib || participant.event === 'Входной билет') ? [{
            bib: participant.bib || '',
            event: participant.event,
            issuanceStatus: participant.issuanceStatus || 'not_issued',
            issuedAt: participant.issuedAt,
            issuedBy: participant.issuedBy
          }] : [],
          club: participant.club,
          phone: participant.phone,
          gender: participant.gender,
          category: participant.category
        });
      }
    });

    this.mergedParticipants = Array.from(mergedMap.values());
  }

  hasIssuedNumbers(participant: any): boolean {
    if (!participant.allBibNumbers || participant.allBibNumbers.length === 0) {
      return false;
    }

    return participant.allBibNumbers.some((bibItem: any) =>
      bibItem.issuanceStatus === 'issued'
    );
  }

  getParticipantIssuanceStatus(participant: any): 'issued' | 'partially_issued' | 'not_issued' {
    if (!participant.allBibNumbers || participant.allBibNumbers.length === 0) {
      return 'not_issued';
    }

    // Исключаем входные билеты из подсчета статуса выдачи
    const nonEntryTicketBibs = participant.allBibNumbers.filter((bibItem: any) =>
      bibItem.event !== 'Входной билет'
    );

    if (nonEntryTicketBibs.length === 0) {
      return 'not_issued';
    }

    const issuedBibs = nonEntryTicketBibs.filter((bibItem: any) =>
      bibItem.issuanceStatus === 'issued'
    );
    const totalBibs = nonEntryTicketBibs.length;

    if (issuedBibs.length === 0) {
      return 'not_issued';
    } else if (issuedBibs.length === totalBibs) {
      return 'issued';
    } else {
      return 'partially_issued';
    }
  }

  hasEntryTicket(participant: any): boolean {
    return true
    if (!participant.allBibNumbers || participant.allBibNumbers.length === 0) {
      return false;
    }

    return participant.allBibNumbers.some((bibItem: any) =>
      bibItem.event === 'Входной билет'
    );
  }

  canIssueNumbers(participant: any): boolean {
    return true
    if (this.hasEntryTicket(participant)) {
      return true;
    }

    return this.isAdmin() || this.isSuperUser();
  }

  getEventStatus(event: any, allBibNumbers: any[]): 'issued' | 'partially_issued' | 'not_issued' | 'no_entry_ticket' {
    if (event.name === 'Входной билет') {
      const entryTicketBib = allBibNumbers.find((bib: any) => bib.event === 'Входной билет');
      return entryTicketBib ? 'issued' : 'no_entry_ticket';
    }

    const eventBibs = allBibNumbers.filter((bib: any) => bib.event === event.name);

    if (eventBibs.length === 0) {
      return 'not_issued';
    }

    const issuedBibs = eventBibs.filter((bib: any) => bib.issuanceStatus === 'issued');
    const totalBibs = eventBibs.length;

    if (issuedBibs.length === 0) {
      return 'not_issued';
    } else if (issuedBibs.length === totalBibs) {
      return 'issued';
    } else {
      return 'partially_issued';
    }
  }

  getEventStatusIcon(status: string): string {
    switch (status) {
      case 'issued':
        return 'check_circle';
      case 'partially_issued':
        return 'warning';
      case 'no_entry_ticket':
        return '';
      default:
        return 'schedule';
    }
  }

  getEventStatusColor(status: string): string {
    switch (status) {
      case 'issued':
        return 'text-success';
      case 'partially_issued':
        return 'text-warning';
      case 'no_entry_ticket':
        return 'text-danger';
      default:
        return 'text-muted';
    }
  }

  getEventStatusText(status: string): string {
    switch (status) {
      case 'issued':
        return 'Выдано';
      case 'partially_issued':
        return 'Частично выдано';
      case 'no_entry_ticket':
        return 'Нет входного билета';
      default:
        return 'Не выдано';
    }
  }

  issueParticipant(participant: any): void {
    if (this.selectedEventsForIssuance.length === 0) {
      this.notifyService.showError('Выберите хотя бы одну дистанцию');
      return;
    }

    console.log('Выдача участника:', participant, 'на дистанции:', this.selectedEventsForIssuance);
    this.notifyService.showSuccess('Участник выдан на выбранные дистанции');
  }

  checkEventType(): void {
    this.isIssuanceEvent = this.currentEvent?.type === 'issuance';
    if (this.isIssuanceEvent) {
      this.mergeParticipantsByFioAndBirthYear();
    }
  }

  openIssuanceDialog(content: any, participant: any): void {
    if (!this.canIssueNumbers(participant)) {
      if (!this.hasEntryTicket(participant)) {
        this.notifyService.showError('Нельзя выдавать номера участнику без входного билета. Только администраторы могут это делать.');
      } else {
        this.notifyService.showError('Недостаточно прав для выдачи номеров.');
      }
      return;
    }

    const eventToParticipantIds = new Map<string, string[]>();

    if (participant.participantIds) {
      participant.participantIds.forEach((item: any) => {
        if (!eventToParticipantIds.has(item.event)) {
          eventToParticipantIds.set(item.event, []);
        }
        eventToParticipantIds.get(item.event).push(item.id);
      });
    }

    this.issuanceParticipant = {
      id: participant.id,
      surname: participant.surname,
      name: participant.name,
      dateOfBirth: participant.dateOfBirth,
      gender: participant.gender,
      club: participant.club,
      phone: participant.phone,
      category: participant.category,
      bib: '',
      tag: '',
      allBibNumbers: participant.allBibNumbers || [],
      selectedEvents: participant.events?.map(event => ({
        name: event,
        selected: true,
        disabled: event === 'Входной билет',
        participantIds: eventToParticipantIds.get(event) || []
      })),
      participantIds: participant.participantIds || []
    };
    this.modalService.open(content, { size: 'lg' });
  }

  onSubmitIssuance(participant: any, modal: any): void {
    let selectedEvents = participant.selectedEvents?.filter((event: any) => event.selected)?.map((event: any) => event.name) || [];

    const entryTicketEvent = participant.selectedEvents?.find((event: any) => event.name === 'Входной билет');
    if (entryTicketEvent && !selectedEvents.includes('Входной билет')) {
      selectedEvents.push('Входной билет');
    }

    if (selectedEvents.length === 0) {
      this.notifyService.showError('Выберите хотя бы одну дистанцию');
      return;
    }

    const allParticipantIds = new Set<string>();

    selectedEvents.forEach(eventName => {
      const selectedEvent = participant.selectedEvents?.find((event: any) => event.name === eventName);
      if (selectedEvent && selectedEvent.participantIds) {
        selectedEvent.participantIds.forEach((participantId: string) => {
          allParticipantIds.add(participantId);
        });
      }
    });

    if (allParticipantIds.size === 0) {
      allParticipantIds.add(participant.id);
    }

    console.log('Selected events:', selectedEvents);
    console.log('Participant IDs for selected events:', Array.from(allParticipantIds));

    const issuanceRequests = Array.from(allParticipantIds).map(participantId => {
      return {
        participantId: participantId,
        eventIds: selectedEvents.map(eventName => {
          const event = this.currentEvent.eventConfig?.distances?.find(d => d.name === eventName);
          return event ? event.name : eventName; // Используем название как ID если не найдем
        }),
        tagNumber: participant.tag || null
      };
    });

    let completedRequests = 0;
    const totalRequests = issuanceRequests.length;

    issuanceRequests.forEach(request => {
      const newParticipant = new Participant();
      newParticipant.id = request.participantId;
      newParticipant.surname = participant.surname;
      newParticipant.name = participant.name;
      newParticipant.dateOfBirth = participant.dateOfBirth;
      newParticipant.gender = participant.gender;
      newParticipant.club = participant.club;
      newParticipant.phone = participant.phone;
      newParticipant.category = participant.category;
      newParticipant.bib = participant.bib;
      newParticipant.tag = request.tagNumber;
      newParticipant.event = selectedEvents[0]; // Берем первую дистанцию
      newParticipant.eventId = this.eventId;
      newParticipant.issuanceStatus = 'issued';
      newParticipant.issuedAt = new Date().toISOString();
      newParticipant.issuedBy = this.account.username;

      this.api.issueParticipant(newParticipant).subscribe(
        result => {
          completedRequests++;
          if (completedRequests === totalRequests) {
            this.notifyService.showSuccess(`Участник успешно выдан на ${selectedEvents.length} дистанции`);
            this.loadParticipants();
            modal.close();
          }
        },
        error => {
          this.notifyService.showError('Ошибка при выдаче участника');
        }
      );
    });
  }

  loadEvent() {
    this.api.getEvent(this.eventId).subscribe(
      res => {
        this.currentEvent = res
        this.titleService.setTitle(res.name);
        this.currentEvent.eventConfig?.distances?.forEach(d => {
          if (this.contains(d.name, this.events) == false) {
            this.events.push(d.name)
          }
          d.categories.forEach(c => {
            if (!this.contains(c.name, this.categories)) this.categories.push(c.name)
          })
        })
        this.categories.sort((a, b) => {
          if (a > b) return 1;
          if (a < b) return -1;
          return 0;
        })
        this.checkEventType();
      }
    )
  }

  getShortString(str: string): string {
    if (str?.length > 20) return str.substring(0, 20) + "..."; else return str
  }

  getStringIfEmpty(str: string): string {
    if (str == "" || str == " ") return "Не указано"; else return str
  }

  loadAccount() {
    this.api.getAccountSettings().subscribe(
      res => this.account = res
    )
  }

  isAdmin() {
    return this.account.role == UserRoles.admin || this.account.role == UserRoles.super_admin
  }

  isSuperUser() {
    return this.account.role == UserRoles.super_admin
  }

  sortWithCurrentSort() {
    switch (this.currentSort.sortField) {
      case SortFields.bib:
        this.sortByBib(false);
        break;
      case SortFields.surname:
        this.sortBySurname(false);
        break;
      case SortFields.name:
        this.sortByName(false);
        break;
      case SortFields.birthDate:
        this.sortByBirthDate(false);
        break;
      case SortFields.event:
        this.sortByEvent(false);
        break;
      default:
        this.sortBySurname(false);
        break;
    }
  }

  loadParticipants() {
    this.isLoading = true
    this.api.getParticipants(this.eventId).subscribe(
      res => {
        this.participants = res
        this.sortWithCurrentSort()
        this.filteredParticipants.forEach(x => this.participants.push(x))
        this.isLoading = false
        this.events.sort((a, b) => {
          try {
            let _a = a.match(/(\d+)/)?.[0] || '0'
            let _b = b.match(/(\d+)/)?.[0] || '0'
            if (+_a > +_b) return 1
            if (+_a < +_b) return -1
            return 0
          } catch (ex) {
            return a.localeCompare(b)
          }
        })

        if (this.isIssuanceEvent) {
          this.mergeParticipantsByFioAndBirthYear();
        }
      },
      err => {
        this.isLoading = false
      }
    )
  }

  parseRouteParams(params: string) {
    var splitted = params.split(";")
    this.eventId = splitted[0];
  }

  ngOnInit() {
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(searchTerm => {
      this.performSearch(searchTerm);
    });

    this.loadParticipants();

    // Debug: Log mobile view status
    console.log('Mobile view debug:', {
      isIssuanceEvent: this.isIssuanceEvent,
      participantsLength: this.participants?.length,
      mergedParticipantsLength: this.mergedParticipants?.length,
      searchQuery: this.searchQuery
    });
  }

  sortByBib(withChangeOrder: boolean = true) {
    this.currentSort.sortField = SortFields.bib
    if (withChangeOrder) {
      if (this.currentSort.sortType == SortTypes.asc) this.currentSort.sortType = SortTypes.desc; else this.currentSort.sortType = SortTypes.asc
    }
    this.participants = this.participants.sort((a, b) => {
      const aBib = a.bib;
      const bBib = b.bib;

      const aEmpty = (aBib === null || aBib === undefined || aBib === '' || String(aBib).trim() === '');
      const bEmpty = (bBib === null || bBib === undefined || bBib === '' || String(bBib).trim() === '');

      if (aEmpty && !bEmpty) {
        return 1;
      }
      if (bEmpty && !aEmpty) {
        return -1;
      }

      if (aEmpty && bEmpty) {
        return 0;
      }

      const aNum = +aBib;
      const bNum = +bBib;

      if (aNum > bNum) {
        return this.currentSort.sortType == SortTypes.asc ? 1 : -1;
      }
      if (aNum < bNum) {
        return this.currentSort.sortType == SortTypes.asc ? -1 : 1;
      }
      return 0;
    })
  }

  sortBySurname(withChangeOrder: boolean = true) {
    this.currentSort.sortField = SortFields.surname
    if (withChangeOrder) {
      if (this.currentSort.sortType == SortTypes.asc) this.currentSort.sortType = SortTypes.desc; else this.currentSort.sortType = SortTypes.asc
    }
    this.participants = this.participants.sort((a, b) => {
      if (a.surname > b.surname) {
        if (this.currentSort.sortType == SortTypes.asc)
          return 1;
        else
          return -1
      }
      if (a.surname < b.surname) {
        if (this.currentSort.sortType == SortTypes.asc)
          return -1;
        else
          return 1
      }
      return 0
    })
  }

  sortByName(withChangeOrder: boolean = true) {
    this.currentSort.sortField = SortFields.name
    if (withChangeOrder) {
      if (this.currentSort.sortType == SortTypes.asc) this.currentSort.sortType = SortTypes.desc; else this.currentSort.sortType = SortTypes.asc
    }
    this.participants = this.participants.sort((a, b) => {
      if (a.name > b.name) {
        if (this.currentSort.sortType == SortTypes.asc)
          return 1;
        else
          return -1
      }
      if (a.name < b.name) {
        if (this.currentSort.sortType == SortTypes.asc)
          return -1;
        else
          return 1
      }
      return 0
    })
  }

  sortByEvent(withChangeOrder: boolean = true) {
    this.currentSort.sortField = SortFields.event
    if (withChangeOrder) {
      if (this.currentSort.sortType == SortTypes.asc) this.currentSort.sortType = SortTypes.desc; else this.currentSort.sortType = SortTypes.asc
    }
    this.participants = this.participants.sort((a, b) => {
      if (a.event > b.event) {
        if (this.currentSort.sortType == SortTypes.asc)
          return 1;
        else
          return -1
      }
      if (a.event < b.event) {
        if (this.currentSort.sortType == SortTypes.asc)
          return -1;
        else
          return 1
      }
      return 0
    })
  }

  sortByBirthDate(withChangeOrder: boolean = true) {
    this.currentSort.sortField = SortFields.birthDate;

    if (withChangeOrder) {
      this.currentSort.sortType = this.currentSort.sortType === SortTypes.asc
        ? SortTypes.desc
        : SortTypes.asc;
    }

    this.participants = this.participants.sort((a, b) => {
      if (!a.dateOfBirth && !b.dateOfBirth) return 0;
      if (!a.dateOfBirth) return 1;
      if (!b.dateOfBirth) return -1;

      const dateA = new Date(a.dateOfBirth);
      const dateB = new Date(b.dateOfBirth);

      if (isNaN(dateA.getTime()) && isNaN(dateB.getTime())) return 0;
      if (isNaN(dateA.getTime())) return 1;
      if (isNaN(dateB.getTime())) return -1;

      const comparison = dateA.getTime() - dateB.getTime();

      return this.currentSort.sortType === SortTypes.asc ? comparison : -comparison;
    });
  }

  formatForInputDate(inputDate) {
    try {
      return inputDate.split("/").reverse().join("-");
    } catch (e) {
      return ""
    }
  }

  format(inputDate) {
    try {
      return inputDate.split("-").reverse().join("/");
    } catch (e) {
      return ""
    }
  }

  openEditParticipantDialog(content: any, participant: Participant) {
    console.log('Original participant:', participant)
    console.log('Original participant event:', participant.event)
    this.participantToEdit = new Participant();
    this.participantToEdit.id = participant.id
    this.participantToEdit.eventId = participant.eventId
    this.participantToEdit.bib = participant.bib
    this.participantToEdit.tag = participant.tag
    this.participantToEdit.name = participant.name
    this.participantToEdit.surname = participant.surname
    this.participantToEdit.club = participant.club
    this.participantToEdit.phone = participant.phone
    this.participantToEdit.dateOfBirth = this.formatForInputDate(participant.dateOfBirth)
    this.participantToEdit.gender = participant.gender
    this.participantToEdit.category = participant.category
    this.participantToEdit.event = participant.event || ""
    this.participantToEdit.uin = participant.uin
    this.participantToEdit.externalId = participant.externalId
    this.participantToEdit.isFromOtherEvent = participant?.isFromOtherEvent
    this.participantToEdit.eventName = participant?.eventName
    this.participantToEdit.eventShortName = participant.eventShortName
    this.modalService.open(content,
      {
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
      }).result.then(
      (result) => {
        if (this.participantToEdit?.isFromOtherEvent || this.canEdited() == false) {
          this.notifyService.showError("Редактирование участника запрещено")
          return
        }
        if (this.participantToEdit?.bib == null) this.participantToEdit.bib = ""
        if (this.participantToEdit?.event == null || this.participantToEdit?.event === undefined) this.participantToEdit.event = ""
        try {
          this.participantToEdit.dateOfBirth = this.format(this.participantToEdit.dateOfBirth)
        } catch (e) {
          console.log(e)
        }
        console.log('Participant to edit:', this.participantToEdit)
        console.log('Event field value:', this.participantToEdit.event)
        console.log('Event field type:', typeof this.participantToEdit.event)
        console.log('Event field length:', this.participantToEdit.event?.length)
        this.api.updateParticipant(this.eventId, this.participantToEdit).subscribe(
          result => {
            this.notifyService.showSuccess("Обновлено")
            this.loadParticipants()
          },
          error => {
            this.notifyService.showError(error.error?.message.toString())
          }
        )
        //TODO add updating participant
        // this.api.updatePunch(participant).subscribe(
        //   res => {
        //   },
        //   error => this.notifyService.showError(error.error.message)
        // )
        this.participantToEdit = new Participant()
      },
      (reason) => {
        this.participantToEdit = new Participant()
      });
  }

  openDownloadCSV(content: any) {
    this.api.downloadParticipants(this.eventId).subscribe(
      res => {
        this.participants = res
        try {
          this.events.sort((a, b) => {
            let _a = a.match(/(\d+)/)[0]
            let _b = b.match(/(\d+)/)[0]
            if (+_a > +_b) return 1
            if (+_a < +_b) return -1
            return 0
          })
        } catch (ex) {

        }
        this.sortBySurname(false)
        this.modalService.open(content,
          {
            ariaLabelledBy: 'modal-basic-title',
            centered: false,
          }).result.then(
          (result) => {
          },
          (reason) => {
          });
      },
      err => {

      }
    )
  }

  parseCustomDate(date: string): string {
    let d = date.split("-")
    let newDate = ""
    let dd = ""
    let mm = ""
    let yy = ""
    d.forEach((value, index) => {
      switch (index) {
        case 0: {
          yy = value
          break
        }
        case 1: {
          mm = value
          break
        }
        case 2:
          dd = value
      }
    })
    return `${dd}/${mm}/${yy}`
  }

  uploadCsv($event) {
    try {
      const file: File = $event?.target?.files[0]
      if (file) {
        file.text().then(
          result => {
            let toUpload: Participant[] = []
            if (this.currentEvent.type == "trail") {
              result.split("\n").forEach((x, index) => {
                if (x == "" || index == 0) {
                } else {
                  let resultStr = x.split(";")
                  let uuid = resultStr[0].replace("\"", "").replace("\"", "")
                  let bib = resultStr[1]?.replace("\"", "")?.replace("\"", "")
                  if (bib == "Bib") {

                  } else {
                    let tag = resultStr[2]?.replace("\"", "")?.replace("\"", "")
                    let name = resultStr[3].replace("\"", "").replace("\"", "")
                    let surname = resultStr[4].replace("\"", "").replace("\"", "")
                    let club = resultStr[5].replace("\"", "").replace("\"", "")
                    let phone = resultStr[6].replace("\"", "").replace("\"", "")
                    let birthDate = resultStr[8].replace("\"", "").replace("\"", "")
                    let gender = resultStr[9].replace("\"", "").replace("\"", "")
                    let category = resultStr[10].replace("\"", "").replace("\"", "")
                    let event = resultStr[11].replace("\"", "").replace("\"", "")
                    let p = new Participant();
                    p.externalId = uuid
                    p.bib = bib
                    p.tag = tag
                    p.name = name
                    p.surname = surname
                    p.club = club
                    p.phone = phone
                    p.dateOfBirth = birthDate
                    p.gender = gender
                    p.category = category
                    p.event = event.replace("\r", "")
                    toUpload.push(p)
                  }
                }
              })
            } else {
              result.split("\n").forEach((x, index) => {
                if (x == "" || index == 0) {
                } else {
                  let resultStr = x.split(";")
                  let bib = ""
                  if (bib == "Bib") {

                  } else {
                    let tag = ""
                    let name = resultStr[3].replace("\"", "").replace("\"", "")
                    let surname = resultStr[2].replace("\"", "").replace("\"", "")
                    let club = resultStr[1].replace("\"", "").replace("\"", "")
                    let category = ""
                    let event = resultStr[4].replace("\"", "").replace("\"", "")
                    let phone = resultStr[8].replace("\"", "").replace("\"", "")
                    let birthDate = resultStr[6].replace("\"", "").replace("\"", "")
                    let gender = resultStr[5].replace("\"", "").replace("\"", "")
                    let p = new Participant();
                    p.bib = bib
                    p.tag = tag
                    p.name = name
                    p.surname = surname
                    p.phone = phone
                    p.gender = gender
                    p.club = club
                    p.category = category
                    p.event = event
                    p.dateOfBirth = birthDate
                    if (gender == "Мужской") p.gender = "Male"
                    if (gender == "Женский") p.gender = "Female"
                    if (
                      bib.length > 19 ||
                      tag.length > 19
                    ) {
                      this.notifyService.showError(JSON.stringify(p))
                      return
                    }
                    console.log(p)
                    toUpload.push(p)
                  }
                }
              })
            }
            var fileInput = document.getElementById('upload-csv') as HTMLInputElement;
            fileInput.value = null
            // return
            this.api.uploadParticipants(this.eventId, toUpload).subscribe(
              result => {
                this.participants = result
                this.notifyService.showSuccess("Participants uploaded")
              }
            )
          }
        )
      }
    } catch (ex) {

    }
  }


  lengthForSearch = 5
  isLoading: boolean = true;

  containsParticipant(obj: Participant, list: Participant[]) {
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].id === obj.id) {
        return true;
      }
    }
    return false;
  }

  sortFromOtherEvents() {
    this.participants = this.participants.sort((a, b) => {
      if (a?.isFromOtherEvent) return 1;
      return -1;
    })
  }

  search($event: any) {
    if ($event.length < this.lengthForSearch) {
      this.participants = this.participants.filter((x: Participant) => x.eventId == this.eventId)
      this.filteredParticipants = []
    } else {
      if (this.searchQuery != "" && this.searchQuery.length >= this.lengthForSearch) {
        this.isLoading = true
        this.api.searchParticipants(this.eventId, this.searchQuery).subscribe(
          result => {
            let toAdd: Participant[] = []
            result.filter((x: Participant) => x.eventId != this.eventId).forEach(x => {
              x.isFromOtherEvent = true
              if (this.containsParticipant(x, this.participants) == false) {
                toAdd.push(x)
              }
            })
            toAdd = toAdd.sort((a, b) => {
              if (a.surname > b.surname) {
                return 1;
              }
              if (a.surname < b.surname) {
                return -1;
              }
              return 0
            })
            this.participants = this.participants.concat(toAdd)
            toAdd.forEach(x => {
              // this.participants.push(x)
              if (this.containsParticipant(x, this.filteredParticipants) == false)
                this.filteredParticipants.push(x)
            })
            this.sortFromOtherEvents()
            this.isLoading = false
          }
        )
      }
    }
  }

  downloadCSV() {
    if (this.currentEvent.type == "trail") {
      let s = "" +
        "bib;" +
        "tag;" +
        "name;" +
        "surname;" +
        "club;" +
        "phone;" +
        "Date of Birth;" +
        "Gender;" +
        "Event;" +
        "category\n";
      this.participants.forEach((x: Participant) => {
        s += `${x.bib?.replace("undefined", "") || ""};${x.tag?.replace("undefined", "") || ""};${x.name?.replace("undefined", "") || ""};${x.surname?.replace("undefined", "") || ""};${x.club?.replace("undefined", "") || ""};${x.phone?.replace("undefined", "") || ""};${this.convertDateFormat(x.dateOfBirth, this.currentDateFormat)};${x.gender};${x.event?.replace("undefined", "") || ""};${x.category?.replace("undefined", "") || ""}\r\n`
      })
      const url = 'data:text/csv;charset=utf-8,' + s.replaceAll("undefined", "");
      const link = document.createElement('a');
      link.download = `upload-to-copernico-all.csv`;
      link.href = url.toString();
      document.body.appendChild(link);
      link.click();
    } else {
      this.downloadCSVOrient()
    }
  }

  downloadCSVOrient() {
    let s = "";
    this.participants.forEach((x: Participant) => {
      var bib = x.bib
      if (bib == "") {
        return
        bib = "0"
      }
      s += `${x.surname} ${x.name}\t${bib}\n`
    })
    if (s == "") {
      this.notifyService.showInfo("Список для экспорта пуст")
      return
    }
    this.clipboard.copy(s)
    const url = 'data:text/csv;charset=utf-8,%EF%BB%BF' + s;
    const link = document.createElement('a');
    link.download = `upload-to-sportorg.txt`;
    link.href = url.toString();
    document.body.appendChild(link);
    link.click();
    this.notifyService.showSuccess("Скопировано в буфер обмена")
  }

  downloadCSVWithEvent(event) {
    let s = "" +
      "bib;" +
      "tag;" +
      "name;" +
      "surname;" +
      "club;" +
      "phone;" +
      "Date of Birth;" +
      "Gender;" +
      "Event;" +
      "category\n";
    this.participants.forEach((x: Participant) => {
      if (x?.event?.includes(event)) {
        s += `${x.bib?.replace("undefined", "") || ""};${x.tag?.replace("undefined", "") || ""};${x.name?.replace("undefined", "") || ""};${x.surname?.replace("undefined", "") || ""};${x.club?.replace("undefined", "") || ""};${x.phone?.replace("undefined", "") || ""};${this.convertDateFormat(x.dateOfBirth, this.currentDateFormat)};${x.gender};${x.event};${x.category?.replace("undefined", "") || ""}\r\n`
      }
    })
    const url = 'data:text/csv;charset=utf-8,%EF%BB%BF' + s.replaceAll("undefined", "");
    const link = document.createElement('a');
    link.download = `upload-to-copernico-${event}.csv`;
    link.href = url;
    document.body.appendChild(link);
    link.click();
  }

  currentDateFormat: string = "DD/MM/YYYY"

  convertDateFormat(inputDate: string, outputFormat: string): string | null {
    const inputFormats = [
      'YYYY-MM-DD',
      'DD.MM.YYYY',
      'DD/MM/YYYY',
      'MM/DD/YYYY',
      'DD-MM-YYYY',
      'YYYY/MM/DD',
      'DD.MM.YY',
      'DD/MM/YY',
      'MM-DD-YYYY',
      'YYYY.MM.DD'
    ];

    function createRegexFromFormat(format: string): RegExp {
      let pattern = format
        .replace(/YYYY/g, '(\\d{4})')
        .replace(/YY/g, '(\\d{2})')
        .replace(/MM/g, '(\\d{1,2})')
        .replace(/DD/g, '(\\d{1,2})')
        .replace(/[-\.\/]/g, '[-\\.\\/]');
      return new RegExp(`^${pattern}$`);
    }

    function parseByFormat(dateStr: string, format: string): Date | null {
      const regex = createRegexFromFormat(format);
      const match = dateStr.match(regex);

      if (!match) return null;

      const formatParts = format.match(/(YYYY|YY|MM|DD)/g) || [];
      const values = match.slice(1);

      let year = 0, month = 0, day = 1;

      formatParts.forEach((part, index) => {
        const value = parseInt(values[index]);
        switch (part) {
          case 'YYYY':
            year = value;
            break;
          case 'YY':
            year = value < 50 ? 2000 + value : 1900 + value;
            break;
          case 'MM':
            month = value - 1;
            break;
          case 'DD':
            day = value;
            break;
        }
      });

      const date = new Date(year, month, day);

      if (date.getFullYear() !== year ||
        date.getMonth() !== month ||
        date.getDate() !== day) {
        return null;
      }

      return date;
    }

    let parsedDate: Date | null = null;

    for (const format of inputFormats) {
      parsedDate = parseByFormat(inputDate, format);
      if (parsedDate) break;
    }

    if (!parsedDate) {
      return null;
    }

    return this.formatDate(parsedDate, outputFormat);
  }

  formatDate(date: Date, format: string): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const shortYear = year.toString().slice(-2);

    return format
      .replace(/YYYY/g, year.toString())
      .replace(/YY/g, shortYear)
      .replace(/MM/g, month)
      .replace(/DD/g, day);
  }

  getTextForApplyButton() {
    if (this.participantToEdit?.isFromOtherEvent) return "Закрыть"
    if (this.canEdited() == false) return "Регистрация закрыта в " + millisToTime(Date.parse(this.findDistance().offlineRegistrationEndsAt))
    if (this?.participantToEdit?.isFromOtherEvent) return "Закрыть"; else return "Сохранить"
  }

  findDistance() {
    return this.currentEvent?.eventConfig?.distances?.find(x => x?.name == this?.participantToEdit?.event)
  }

  canEdited() {
    if (this.account.role == UserRoles.super_admin || this.account.role == UserRoles.admin) return true
    if (this.participantToEdit?.isFromOtherEvent) return false
    let found = this.findDistance()
    if (found != null) {
      let diff = Date.parse(found?.offlineRegistrationEndsAt) - Date.now()
      return diff >= 0;
    } else {
      return true
    }
  }

  msToTime(s) {
    const ms = s % 1000;
    s = (s - ms) / 1000;
    const secs = s % 60;
    let secsStr = "";
    if (secs < 10) {
      secsStr = `0${secs}`
    } else {
      secsStr = (secs).toString()
    }
    s = (s - secs) / 60;
    const mins = s % 60;
    let minsStr = "";
    if (mins < 10) {
      minsStr = `0${mins}`
    } else {
      minsStr = (mins).toString()
    }
    const hrs = ((s - mins) / 60);
    let hrsString = "";
    if (hrs < 10) {
      hrsString = `0${hrs}`
    } else {
      hrsString = hrs.toString()
    }
    return hrsString + ':' + minsStr + ':' + secsStr;
  }

  getStartForParticipant(participantToEdit: Participant) {
    let distance = this.findDistance()
    if (distance == null) return "Не указано"
    let start = Date.parse(distance?.estimatedStartTimestamp)
    let diff = start - Date.now()
    let startTimeInString = millisToTime(start)
    if (diff < 0) return startTimeInString + " (уже прошёл)"
    else {
      return startTimeInString + ` (через ${this.msToTime(diff)})`
    }

  }

  getEndOfflineRegistrationTime(participantToEdit: Participant) {
    let distance = this.findDistance()
    if (distance == null) return "Не указано"
    let diff = Date.parse(distance?.offlineRegistrationEndsAt) - Date.now()
    let endText = ""
    if (diff < 0) {
      endText = " (завершена)"
      return millisToTime(Date.parse(distance?.offlineRegistrationEndsAt)) + endText
    } else {
      endText = ` (осталось ${this.msToTime(diff)})`
    }
    return millisToTime(Date.parse(distance?.offlineRegistrationEndsAt)) + endText
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe()
  }

  openBibAssignDialog(content) {
    this.filteredParticipantsForMassAssign = [...this.participants];
    this.selectedParticipants.clear();
    this.bibAssignForm.reset();
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg'
    });
  }

  filterParticipants() {
    const query = this.bibAssignForm.get('searchQuery').value?.toLowerCase() || '';
    this.filteredParticipantsForMassAssign = this.participants.filter(p =>
      (p.name?.toLowerCase() || '').includes(query) ||
      (p.surname?.toLowerCase() || '').includes(query) ||
      (p.club?.toLowerCase() || '').includes(query)
    );
  }

  toggleParticipantSelection(participantId: string) {
    if (this.selectedParticipants.has(participantId)) {
      this.selectedParticipants.delete(participantId);
    } else {
      this.selectedParticipants.add(participantId);
    }
  }

  selectAllFiltered() {
    this.filteredParticipantsForMassAssign.forEach(p => {
      this.selectedParticipants.add(p.id);
    });
  }

  deselectAllFiltered() {
    this.filteredParticipantsForMassAssign.forEach(p => {
      this.selectedParticipants.delete(p.id);
    });
  }

  isAllFilteredSelected(): boolean {
    return this.filteredParticipantsForMassAssign.length > 0 &&
      this.filteredParticipantsForMassAssign.every(p => this.selectedParticipants.has(p.id));
  }

  isParticipantSelected(participantId: string): boolean {
    return this.selectedParticipants.has(participantId);
  }

  onSubmitBibAssign(modal) {
    if (this.bibAssignForm.valid) {
      const {bibNumbers} = this.bibAssignForm.value;
      const parsedNumbers = this.parseBibNumbers(bibNumbers);

      if (parsedNumbers.length === 0) {
        this.toastr.error('Неверный формат номеров');
        return;
      }

      if (this.selectedParticipants.size === 0) {
        this.toastr.error('Выберите хотя бы одного участника');
        return;
      }

      if (parsedNumbers.length !== this.selectedParticipants.size) {
        this.toastr.error('Количество номеров должно совпадать с количеством выбранных участников');
        return;
      }

      const duplicates = this.checkDuplicates(parsedNumbers);
      if (duplicates.length > 0) {
        this.toastr.warning(`Следующие номера уже используются: ${duplicates.join(', ')}`);
        return;
      }

      const selectedParticipantsList = this.filteredParticipantsForMassAssign.filter(p =>
        this.selectedParticipants.has(p.id)
      );

      // Обновляем номера участников
      selectedParticipantsList.forEach((participant, index) => {
        participant.bib = parsedNumbers[index].toString();
      });

      // Отправляем обновления на сервер
      Promise.all(selectedParticipantsList.map(participant =>
        this.api.updateParticipant(this.currentEvent.id, participant).toPromise()
      )).then(() => {
        this.toastr.success('Номера успешно присвоены');
        this.bibAssignForm.reset();
        this.selectedParticipants.clear();
        modal.close();
        this.loadParticipants();
      }).catch(error => {
        this.toastr.error('Ошибка при присвоении номеров');
        console.error('Error assigning bibs:', error);
      });
    }
  }

  parseBibNumbers(input: string): number[] {
    const numbers: number[] = [];
    var splitter = ";"
    if (input.includes(";") == false) splitter = " "
    const parts = input.split(splitter).map(p => p.trim());

    for (const part of parts) {
      if (part.includes('-')) {
        const [start, end] = part.split('-').map(n => parseInt(n.trim()));
        if (!isNaN(start) && !isNaN(end) && start <= end) {
          for (let i = start; i <= end; i++) {
            if (i >= 1 && i <= 9999) {
              numbers.push(i);
            }
          }
        }
      } else {
        const num = parseInt(part);
        if (!isNaN(num) && num >= 1 && num <= 9999) {
          numbers.push(num);
        }
      }
    }

    return numbers;
  }

  checkDuplicates(numbers: number[]): number[] {
    return numbers.filter(num => this.participants.some(p => p.bib === num.toString()));
  }

  getStatistics() {
    const stats = {
      total: this.participants.length,
      withoutBib: this.participants.filter(p => !p.bib).length,
      started: this.participants.filter(p => p.estimatedStart).length,
      byCategory: {},
      byEvent: {},
      byClub: {}
    };


    // Подсчет участников без номеров по категориям
    this.participants.forEach(p => {
      if (p.category) {
        stats.byCategory[p.category] = (stats.byCategory[p.category] || 0) + 1;
      }
    });
    this.participants.forEach(p => {
      if (p.event) {
        if (!stats.byEvent[p.event]) {
          stats.byEvent[p.event] = {
            total: 0,
            assigned: 0
          };
        }
        stats.byEvent[p.event].total++;
        if (p.bib) stats.byEvent[p.event].assigned++;
      }
    });

    this.participants.forEach(p => {
      if (p.club) {
        stats.byClub[p.club] = (stats.byClub[p.club] || 0) + 1;
      }
    });

    return stats;
  }

  getIssuanceStatistics() {
    if (!this.mergedParticipants || this.mergedParticipants.length === 0) {
      return {
        totalParticipants: 0,
        totalBibs: 0,
        issuedBibs: 0,
        notIssuedBibs: 0,
        participantsWithoutEntryTicket: 0,
        participantsWithEntryTicket: 0,
        byEvent: {},
        byIssuanceStatus: {
          issued: 0,
          partially_issued: 0,
          not_issued: 0
        }
      };
    }

    const stats = {
      totalParticipants: this.mergedParticipants.length,
      totalBibs: 0,
      issuedBibs: 0,
      notIssuedBibs: 0,
      participantsWithoutEntryTicket: 0,
      participantsWithEntryTicket: 0,
      byEvent: {},
      byIssuanceStatus: {
        issued: 0,
        partially_issued: 0,
        not_issued: 0
      }
    };
    this.mergedParticipants.forEach(participant => {
      if (this.hasEntryTicket(participant)) {
        stats.participantsWithEntryTicket++;
      } else {
        stats.participantsWithoutEntryTicket++;
      }

      const issuanceStatus = this.getParticipantIssuanceStatus(participant);
      stats.byIssuanceStatus[issuanceStatus]++;

      if (participant.allBibNumbers) {
        participant.allBibNumbers.forEach(bibItem => {
          if (bibItem.event !== 'Входной билет') {
            stats.totalBibs++;
            if (bibItem.issuanceStatus === 'issued') {
              stats.issuedBibs++;
            } else {
              stats.notIssuedBibs++;
            }
          }

          if (!stats.byEvent[bibItem.event]) {
            stats.byEvent[bibItem.event] = {
              total: 0,
              issued: 0,
              notIssued: 0
            };
          }
          stats.byEvent[bibItem.event].total++;
          if (bibItem.issuanceStatus === 'issued') {
            stats.byEvent[bibItem.event].issued++;
          } else {
            stats.byEvent[bibItem.event].notIssued++;
          }
        });
      }
    });

    return stats;
  }

  openStatisticsDialog(content) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg'
    });
  }

  toggleFullScreen() {
    if (!this.isFullScreen) {
      this.openFullScreen();
    } else {
      this.closeFullScreen();
    }
  }

  private openFullScreen() {
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if ((elem as any).mozRequestFullScreen) { /* Firefox */
      (elem as any).mozRequestFullScreen();
    } else if ((elem as any).webkitRequestFullscreen) { /* Chrome, Safari & Opera */
      (elem as any).webkitRequestFullscreen();
    } else if ((elem as any).msRequestFullscreen) { /* IE/Edge */
      (elem as any).msRequestFullscreen();
    }
    this.isFullScreen = true;
  }

  private closeFullScreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).mozCancelFullScreen) { /* Firefox */
      (document as any).mozCancelFullScreen();
    } else if ((document as any).webkitExitFullscreen) { /* Chrome, Safari and Opera */
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) { /* IE/Edge */
      (document as any).msExitFullscreen();
    }
    this.isFullScreen = false;
  }

  onBibKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === 'Done') { // Проверяем, была ли нажата клавиша Enter
      event.preventDefault(); // Предотвращаем стандартное поведение
      this.hideKeyboard();   // Вызываем метод для скрытия клавиатуры
    }
  }

  hideKeyboard(): void {
    const activeElement = document.activeElement as HTMLElement;
    if (activeElement && activeElement.blur) {
      activeElement.blur(); // Убираем фокус с текущего элемента
    }
  }

  getTimestamp(time: string): string {
    try {
      let parsed = new Date(time).toLocaleTimeString("ru-RU")
      if (parsed == "Invalid Date") return ""
      return parsed
    } catch (e) {
      return ""
    }
  }

  openCreateParticipantDialog(content: any) {
    this.createParticipantForm.reset();
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg'
    });
  }

  onSubmitCreateParticipant(modal: any) {
    // if (this.createParticipantForm.valid) {
    const formValue = this.createParticipantForm.value;
    const newParticipant: Participant = {
      ...formValue,
      eventId: this.eventId,
      dateOfBirth: formValue.dateOfBirth
    };


    this.api.uploadParticipants(this.eventId, [newParticipant]).subscribe(
      (result) => {
        this.toastr.success('Участник успешно добавлен');
        this.loadParticipants();
        modal.dismiss()
        modal.close();
      },
      (error) => {
        this.toastr.error('Ошибка при добавлении участника');
        console.error('Error creating participant:', error);
      }
    );
    // }
  }

  formatDateForBackend(date: string): string {
    if (!date) return '';
    const [year, month, day] = date.split('-');
    return `${day}/${month}/${year}`;
  }

  capitalize(word: string): string {
    if (!word) return "";
    return word[0].toUpperCase() + word.slice(1).toLowerCase();
  }

  getMissing(items: Participant[], from: number, to: number): number[] {
    const values = new Set(items.map(it => it.bib));
    const missing: number[] = [];

    for (let i = from; i <= to; i++) {
      if (!values.has(i.toString())) {
        missing.push(i);
      }
    }

    return missing;
  }

  findDuplicates(items: Participant[]): string[] {
    const seen = new Set<string>();
    const duplicates = new Set<string>();

    for (const it of items) {
      if (seen.has(it.bib)) {
        duplicates.add(it.bib);
      } else {
        seen.add(it.bib);
      }
    }

    return Array.from(duplicates);
  }

  onSubmitMassEdit() {
    // let miss = this.getMissing(this.participants, 101, 300)
    // this.notifyService.showInfo(miss)
    // console.log(miss)
    // console.log(this.findDuplicates(this.participants))
    // return
    Promise.all(this.participants.map(participant => {
        console.log(this.capitalize(participant.name) + ' ' + this.capitalize(participant.surname) + ' ' + this.capitalize(participant.club))
        // participant.name = this.capitalize(participant.name)
        // participant.surname = this.capitalize(participant.surname)
        // participant.club = this.capitalize(participant.club)
        // console.log(participant)
        //   participant.event = "Mass"
          // participant.tag = participant.bib
        // this.api.updateParticipant(this.currentEvent.id, participant).toPromise()
      }
    )).then(() => {
      this.notifyService.showSuccess('Массовое редактировние успешно!');
      this.loadParticipants();
      this.searchQuery = ""
      this.massEditForm.reset();
    }).catch(error => {
      console.error('Error assigning numbers:', error);
      this.notifyService.showError('Ошибка при присвоении номеров');
    }).finally(() => {
      this.isLoading = false;
    });
  }

  onSubmitAssignCategories() {
    this.notifyService.showInfo("Присвоение начато")
    this.api.assignCategories(this.eventId).subscribe(
      res => {
        this.participants = res
        this.sortBySurname(false)
        this.notifyService.showSuccess('Присвоение успешно!');
      },
      err => {

      }
    )
  }

  transferParticipant(participantToEdit: Participant) {
    this.api.transferParticipant(participantToEdit.id, this.eventId).subscribe(
      res => {
        this.notifyService.showSuccess('Успешный трансфер!');
      },
      err => {
        this.notifyService.showError('Ошибка при трансфере');
      }
    )
  }

  assignCategoryForParticipant(participantToEdit: Participant) {
    this.api.assignCategoryForParticipant(this.eventId, participantToEdit.id).subscribe(
      res => {
        this.notifyService.showSuccess('Успешное присвоение!');
      },
      err => {
        // this.notifyService.showError('Ошибка при трансфере');
      }
    )
  }

  openUploadCSV(uploadContent: any) {
    this.modalService.open(uploadContent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
      windowClass: 'modal-fullwidth',
    });
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      this.parseFilePreview(file);
    }
  }

  parseFilePreview(file: File): void {
    const reader = new FileReader();

    reader.onload = (e: any) => {
      try {
        if (file.name.endsWith('.csv')) {
          this.parseCSV(e.target.result);
        } else if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
          this.parseXLSX(e.target.result);
        }
      } catch (error) {
        console.error('Ошибка при парсинге файла:', error);
      }
    };

    if (file.name.endsWith('.csv')) {
      reader.readAsText(file);
    } else {
      reader.readAsArrayBuffer(file);
    }
  }

  parseCSV(content: string): void {
    const lines = content.split('\n').filter(line => line.trim());
    if (lines.length > 0) {
      const headers = lines[0].split(';').map(h => h.trim().replace(/"/g, ''));
      this.previewHeaders = headers;
      this.fileColumns = headers.map(name => ({
        name,
        mappedField: '',
        selected: false
      }));

      this.previewData = lines.slice(1).map(line =>
        line.split(';').map(cell => cell.trim().replace(/"/g, ''))
      );

      // Автоматическое сопоставление при первой загрузке
      if (this.columnMode === 'auto') {
        this.autoMapColumns();
      }
    }
  }

  parseXLSX(buffer: ArrayBuffer): void {
    try {
      const workbook = XLSX.read(buffer, {type: 'array'});
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        defval: '',
        raw: false
      }) as any[][];

      if (jsonData.length > 0) {
        this.previewHeaders = jsonData[0].map(header =>
          header ? header.toString().trim() : ''
        );

        this.fileColumns = this.previewHeaders.map(name => ({
          name,
          mappedField: '',
          selected: false
        }));

        this.previewData = jsonData.slice(1).map(row =>
          row.map(cell => cell ? cell.toString().trim() : '')
        );

        if (this.columnMode === 'auto') {
          this.autoMapColumns();
        }
      }
    } catch (error) {
      console.error('Ошибка при парсинге XLSX файла:', error);
      alert('Ошибка при чтении файла Excel. Проверьте формат файла.');
    }
  }

  autoMapColumns(): void {
    this.fileColumns.forEach(column => {
      const normalizedColumnName = column.name.toLowerCase().trim();

      const mappingRules: { [key: string]: string } = {
        'номер': 'bib',
        'bib': 'bib',
        'стартовый номер': 'bib',
        'фамилия': 'surname',
        'surname': 'surname',
        'имя': 'name',
        'name': 'name',
        'клуб': 'club',
        'club': 'club',
        'команда': 'club',
        'телефон': 'phone',
        'phone': 'phone',
        'дата рождения': 'dateOfBirth',
        'birth': 'dateOfBirth',
        'пол': 'gender',
        'gender': 'gender',
        'категория': 'category',
        'category': 'category',
        'дистанция': 'event',
        'дисциплина': 'event',
        'event': 'event',
        'чип': 'tag',
        'tag': 'tag',
        'chip': 'tag'
      };

      for (const [pattern, field] of Object.entries(mappingRules)) {
        if (normalizedColumnName.includes(pattern)) {
          if (!this.isFieldAlreadyMapped(field, -1)) {
            column.mappedField = field;
            break;
          }
        }
      }
    });
  }

  clearColumnMapping(): void {
    this.fileColumns.forEach(column => {
      column.mappedField = '';
    });
  }

  isFieldAlreadyMapped(fieldKey: string, currentIndex: number): boolean {
    return this.fileColumns.some((col, index) =>
      col.mappedField === fieldKey && index !== currentIndex
    );
  }

  getFieldDescription(fieldKey: string): string {
    const field = this.participantFields.find(f => f.key === fieldKey);
    return field ? field.description : '';
  }

  getColumnPreview(columnIndex: number): string {
    if (this.previewData.length > 0 && this.previewData[0][columnIndex]) {
      return this.previewData[0][columnIndex];
    }
    return '';
  }

  onColumnMappingChange(): void {
  }

  getMappingWarnings(): string[] {
    const warnings: string[] = [];

    const requiredFields = this.participantFields.filter(f => f.required);
    const mappedFields = this.fileColumns
      .filter(col => col.mappedField)
      .map(col => col.mappedField);

    requiredFields.forEach(field => {
      if (!mappedFields.includes(field.key)) {
        warnings.push(`Обязательное поле "${field.displayName}" не сопоставлено`);
      }
    });

    const duplicates = mappedFields.filter((field, index) =>
      mappedFields.indexOf(field) !== index
    );

    if (duplicates.length > 0) {
      warnings.push('Некоторые поля сопоставлены с несколькими столбцами');
    }

    return warnings;
  }

  canUpload(): boolean {
    if (!this.selectedFile) return false;

    if (this.columnMode === 'manual') {
      const mappedColumns = this.fileColumns.filter(col => col.mappedField);
      const warnings = this.getMappingWarnings();

      return mappedColumns.length > 0 && warnings.length === 0;
    }

    return true;
  }

  uploadFile(modal: any): void {
    if (!this.canUpload()) return;

    try {
      const participants = this.convertToParticipants();

      if (participants.length === 0) {
        alert('Нет данных для загрузки');
        return;
      }

      const confirmMessage = `Будет загружено ${participants.length} участников. Продолжить?`;
      if (!confirm(confirmMessage)) {
        return;
      }

      this.notifyService.showInfo("Загрузка начата")
      this.api.uploadParticipants(this.eventId, participants).subscribe(
        res => {
          this.notifyService.showSuccess("Загрузка успешна!")
          this.loadParticipants()
          modal.close('Upload completed');
        },
        error => {
          this.notifyService.showError("Загрузка прервана!")
        }
      )
    } catch (error) {
      console.error('Ошибка конвертации данных:', error);
      alert('Ошибка при обработке данных: ' + error?.message);
    }
  }

  convertToParticipants(): Participant[] {
    const participants: Participant[] = [];

    try {
      const columnMapping: { [columnIndex: number]: string } = {};

      this.fileColumns.forEach((column, index) => {
        if (column.mappedField) {
          columnMapping[index] = column.mappedField;
        }
      });

      this.previewData.forEach((row, rowIndex) => {
        try {
          const participant = new Participant();

          Object.entries(columnMapping).forEach(([columnIndex, fieldName]) => {
            const cellValue = row[parseInt(columnIndex)] || '';
            this.setParticipantField(participant, fieldName, cellValue);
          });

          this.validateAndSetDefaults(participant);

          participants.push(participant);

        } catch (error) {
          console.error(`Ошибка обработки строки ${rowIndex + 1}:`, error);
        }
      });

    } catch (error) {
      console.error('Ошибка конвертации данных:', error);
      throw new Error('Не удалось конвертировать данные в формат участников');
    }

    return participants;
  }

  private parseGender(value: string): string {
    const normalized = value.trim().toLowerCase();

    const maleVariants = [
      "m", "male", "м", "муж", "мужчина", "man", "парень", "юноша", "мужской"
    ];

    const femaleVariants = [
      "f", "female", "ж", "жен", "женщина", "woman", "девушка", "дев", "женский"
    ];

    if (maleVariants.includes(normalized)) {
      return "Male";
    }
    if (femaleVariants.includes(normalized)) {
      return "Female";
    }
    return ""; // Если не удалось определить
  }

  private setParticipantField(participant: Participant, fieldName: string, value: string): void {
    const trimmedValue = value.trim();

    switch (fieldName) {
      case 'bib':
        participant.bib = trimmedValue;
        break;
      case 'tag':
        participant.tag = trimmedValue;
        break;
      case 'name':
        participant.name = trimmedValue;
        break;
      case 'surname':
        participant.surname = trimmedValue;
        break;
      case 'club':
        participant.club = trimmedValue;
        break;
      case 'phone':
        participant.phone = trimmedValue;
        break;
      case 'dateOfBirth':
        participant.dateOfBirth = trimmedValue;
        break;
      case 'gender':
        participant.gender = this.parseGender(trimmedValue)
        break;
      case 'category':
        participant.category = trimmedValue;
        break;
      case 'event':
        participant.event = trimmedValue;
        break;
      case 'uin':
        participant.uin = trimmedValue;
        break;
      case 'externalId':
        participant.externalId = trimmedValue;
        break;
      default:
        console.warn(`Неизвестное поле: ${fieldName}`);
    }
  }

  private validateAndSetDefaults(participant: Participant): void {
    if (!participant.name || !participant.surname) {
      throw new Error('Отсутствуют обязательные поля: имя или фамилия');
    }

    if (!participant.gender) {
      participant.gender = 'Не указан';
    }

    if (!participant.category) {
      participant.category = 'Основная';
    }
  }

  clearTagBib() {
    if (prompt("Подтвердите очистку, введя ID мероприятия") === this.eventId) {
      this.api.clearTagBibInParticipants(this.eventId).subscribe(
        () => {
          this.notifyService.showSuccess('Tag-Bib успешно очищены');
          this.loadParticipants();
        },
        error => {
          this.notifyService.showError('Ошибка при очистке tag-bib');
        }
      );
    } else {
      this.notifyService.showError("Некорректный ID")
    }
  }

  openTagBib() {
    const url = `/events/${this.currentEvent?.id}/tag-bib`;
    window.open(url, '_blank');
  }

  isClubNotUnique(): boolean {
    if (this.createParticipantForm.get('club').value == null || this.createParticipantForm.get('club').value == "") return false
    return this.participants.find(x => x.club == this.createParticipantForm.get('club').value) != null
  }

  trackByParticipant(index: number, participant: any): any {
    return participant.id || index;
  }

  trackByBibNumber(index: number, bib: any): any {
    return bib.bibNumber || index;
  }

  performSearch(searchTerm: string) {
    this.searchQuery = searchTerm;
    this.loadParticipants();
  }

  clearSearch() {
    this.searchQuery = '';
  }

  get showEmptyState(): boolean {
    return this.searchQuery &&
           this.searchQuery.length >= this.lengthForSearch &&
           this.getFilteredParticipants().length === 0;
  }

  getFilteredParticipants(): any[] {
    if (this.isIssuanceEvent) {
      return this.mergedParticipants.filter(p => this.pipe.transform([p], this.searchQuery).length > 0);
    } else {
      return this.participants.filter(p => this.pipe.transform([p], this.searchQuery).length > 0);
    }
  }

  get showTable(): boolean {
    return !this.showEmptyState;
  }
}
